import { ANSWER_MESSAGE, FrameWorkFormatDate, FrameWorkGetPrimaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressGetCurrentUser, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDataOrderForShowAndEdit } from 'orden_express/orders/ordersActions.js';
import { setDateReportsRequested, setfFilterRouteReportProducts, setFilterSelecteduserHistoryClient, setMessageReportsRequested } from 'orden_express/reports/reportsActions.js';
import { requestGetReportHistoryClient, requestGetReportProductsRequested } from 'orden_express/reports/reportsEpic.js';
import { requestGetRoutes } from 'orden_express/routes/routesEpic.js';
import { requestGetUsers, responseGetUsers } from 'orden_express/users/usersEpic.js';
import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';


class ReportHistoryClient extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            filterText: '',
        }
        OrdenExpressValidateSecurity(this);
        this.getUsers();
        this.recoverInformationReport();
    }

    componentDidUpdate(prevProps) {
        if (this.props.reportsReducerState.filterSelecteduserHistoryClient !== prevProps.reportsReducerState.filterSelecteduserHistoryClient) {
            this.recoverInformationReport();
        }
        if (this.props.reportsReducerState.messageReportsRequested !== prevProps.reportsReducerState.messageReportsRequested) {
            this.processMessageState(this.props.reportsReducerState.messageReportsRequested);
        }
    }

    processMessageState = (pStateForMessage) => {
        switch (pStateForMessage) {
            case 1://procesando solicitud
                FrameWorkSimpleMessageState(this, 'Recuperando información', 'Se está procesando ...');
                break;
            case 2:
                FrameWorkHideAlert(this);
                this.props.setMessageReportsRequested(0);
                break;
            case 3:
                var localMessageError = this.props.reportsReducerState.responseGetReportHistoryClient;
                FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
                console.error(localMessageError)
                break;
            default:
                FrameWorkHideAlert(this);
                this.props.setMessageReportsRequested(0);
                break;
        }
    }

    applyFilters = (pContentReport) => {
        try {
            var filter = this.state.filterText.toUpperCase();
            var result = [];
            var localText = '';
            var pos = 0;
            var length = pContentReport.length;
            while (pos < length) {
                var pContent=pContentReport[pos];
                localText =
                    (
                        pContent.idOrder + ' ' +
                        FrameWorkFormatDate(pContent.dispatchDate, '-') + ' ' +
                        FrameWorkFormatDate(pContent.deliveryDate, '-') + ' ' +
                        pContent.userName + ' ' +
                        pContent.deliveryPointName + ' ' +
                        pContent.routeName + ' '
                    );
                localText = localText.toUpperCase();
                var addToShow = localText.includes(filter);
                if (addToShow) {
                    result.push(pContent);
                }
                pos++;
            }
            /*pContentReport.map((pContent) => {
                localText =
                    (
                        pContent.idOrder + ' ' +
                        FrameWorkFormatDate(pContent.dispatchDate, '-') + ' ' +
                        FrameWorkFormatDate(pContent.deliveryDate, '-') + ' ' +
                        pContent.userName + ' ' +
                        pContent.deliveryPointName + ' ' +
                        pContent.routeName + ' '
                    );
                localText = localText.toUpperCase();
                var addToShow = localText.includes(filter);
                if (addToShow) {
                    result.push(pContent);
                }
            });*/
        } catch (ex) {
            return pContentReport;
        }
        return result;
    }


    renderFilters = () => {
        return (
            <FormGroup >
                <Input

                    type='text'
                    placeholder='Buscar'
                    id='idfilterText'
                    value={this.state.filterText}
                    onChange={(newtext) => { this.setState({ filterText: newtext.target.value }) }}
                />
            </FormGroup>
        )
    }

    getUsers = () => {
        if (OrdenExpressIsAdmin(this)) {
            this.props.requestGetUsers();
        } else {
            try {
                var localUser = OrdenExpressGetCurrentUser(this);
                var dataLocaluser = ANSWER_MESSAGE(false, 'Usuario actual del sistema', {}, [localUser]);
                this.props.responseGetUsers(dataLocaluser);
            } catch (__) { }
        }
    }

    getUserList = () => {
        var listOfusers = [];
        var listActiveUsers = [];
        try {
            listOfusers = this.props.userReducerState.responseGetUsers.result || [];
            listActiveUsers = listOfusers;
            /*var pos = 0;
            var lengthOfList = listOfusers.length;
            while (pos < lengthOfList) {
                if (listOfusers[pos].active === 1) {
                    listActiveUsers.push(listOfusers[pos]);
                }
                pos++;
            }*/
        } catch (_) { }

        return (
            listActiveUsers.map((itemUser) => {
                return (
                    { value: itemUser, label: itemUser.name }
                )
            })
        );
    }

    changeUserSelected = (pValue) => {
        this.props.setFilterSelecteduserHistoryClient(pValue);
        //this.setState({ selectedUser: pValue }, () => this.recoverInformationReport());
    }

    getUserSelected = () => {
        return this.props.reportsReducerState.filterSelecteduserHistoryClient;
        //return this.state.selectedUser;
    }

    recoverInformationReport = () => {
        try {
            var parameters = {
                parameterString1: this.getUserSelected().value.id,
            }
            this.props.requestGetReportHistoryClient(parameters);
            this.props.setMessageReportsRequested(1);
        } catch (___) { }
    }

    sendToEditOrderRequested = (pData = null) => {
        try {
            pData['id'] = pData.idOrder;
            this.props.setDataOrderForShowAndEdit(pData);
            OrdenExpressNavegatePath(this, 'editOrder');
        } catch (__) { }
    }

    render = () => {
        var localHistoryClient = [];
        try {
            localHistoryClient = this.props.reportsReducerState.responseGetReportHistoryClient.result || [];
            localHistoryClient = this.applyFilters(localHistoryClient);
        } catch (__) { }
        return (
            <div className='content mt-5 mb-0'>
                {this.state.alert}
                <div className='framework-flexcontainer'>
                    <div>
                        <h4>{'Histórico'}</h4>
                    </div>
                    <div className='text-right framework-flex-rigth'>
                    </div>
                </div>
                <Card className='mt-1 mb-1'>
                    <CardBody>
                        <Row className='framework-v-center'>
                            <Col md='2'>
                                <b>Cliente</b>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Select
                                        className='react-select mb-0 mt-1'
                                        classNamePrefix='react-select'
                                        name='client'
                                        placeholder='Seleccione el cliente'
                                        value={this.getUserSelected()}
                                        options={this.getUserList()}
                                        onChange={value => { this.changeUserSelected(value) }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className='framework-v-center mt-0'>
                            <Col md='2'>
                                <b>Filtros</b>
                            </Col>
                            <Col>
                                {this.renderFilters()}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                {
                    localHistoryClient.map((itemHistoryClient, pIndex) => {
                        return (
                            <Card
                                className={`mb-1 mt-0 ${pIndex % 2 === 0 ? 'bg-gray' : 'bg-white'}`}
                                key={`keyHistoryClient${pIndex}`}
                            >
                                <CardBody>
                                    <div className='framework-flexcontainer'>
                                        <div>
                                            <b>{'Fecha de despacho:'}</b>
                                            {' '}
                                            {FrameWorkFormatDate(itemHistoryClient.dispatchDate, '-')}
                                            <br />
                                            <b>{'Fecha de entrega:'}</b>
                                            {' '}
                                            {FrameWorkFormatDate(itemHistoryClient.deliveryDate, '-')}
                                            <br />
                                            <b>{'Nº orden:'}</b>
                                            {' '}
                                            {itemHistoryClient.idOrder}
                                            <br />
                                            <b>{'Cliente:'}</b>
                                            {' '}
                                            {itemHistoryClient.userName}
                                            <br />
                                            <b>{'Punto de entrega:'}</b>
                                            {' '}
                                            {itemHistoryClient.deliveryPointName}
                                            <br />
                                            <b>{'Ruta asignada:'}</b>
                                            {' '}
                                            {itemHistoryClient.routeName}
                                        </div>
                                        <div className='text-right framework-flex-rigth'>
                                            <Button
                                                className='btn-icon btn-round mt-0 mb-1'
                                                color={FrameWorkGetPrimaryColorButton()}
                                                id={`editOrder${pIndex}`}
                                                type='button'
                                                outline
                                                size='sm'
                                                onClick={value => {
                                                    this.sendToEditOrderRequested(itemHistoryClient);
                                                }}
                                            >
                                                <i className='fa fa-pencil' />
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                target={`editOrder${pIndex}`}
                                            >
                                                {'Detalle orden Nº'}
                                                {' '}
                                                {itemHistoryClient.idOrder}
                                            </UncontrolledTooltip>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        )
                    })
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userReducerState: state.userReducerState,
        reportsReducerState: state.reportsReducerState,
        loginReducerState: state.loginReducerState,
        routesReducerState: state.routesReducerState,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        responseGetUsers: (dataUser) => dispatch(responseGetUsers(dataUser)),
        setDataOrderForShowAndEdit: (dataOrderForShowAndEdit) => dispatch(setDataOrderForShowAndEdit(dataOrderForShowAndEdit)),
        setMessageReportsRequested: (messageReportsRequested) => dispatch(setMessageReportsRequested(messageReportsRequested)),
        setDateReportsRequested: (dateReportsRequested) => dispatch(setDateReportsRequested(dateReportsRequested)),
        setfFilterRouteReportProducts: (filterRouteReportProducts) => dispatch(setfFilterRouteReportProducts(filterRouteReportProducts)),
        setFilterSelecteduserHistoryClient: (filterSelectedUserHistoryClient) => dispatch(setFilterSelecteduserHistoryClient(filterSelectedUserHistoryClient)),

        requestGetRoutes: () => bindActionCreators(dispatch(requestGetRoutes()), dispatch),
        requestGetReportProductsRequested: (deliveryDate) => bindActionCreators(dispatch(requestGetReportProductsRequested(deliveryDate)), dispatch),
        requestGetUsers: () => bindActionCreators(dispatch(requestGetUsers()), dispatch),
        requestGetReportHistoryClient: (reportParameters) => bindActionCreators(dispatch(requestGetReportHistoryClient(reportParameters)), dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportHistoryClient);